/**
 * 工序管理业务逻辑封装。
 */

import { processInfoRequest } from '@/network/requests/processInfo'

/**
 * 获取所有的工序。
 */
var getProcessList = async () => {
	return await processInfoRequest.queryAll()
}

export default {
	getProcessList,
}
